import type { RoleBadgeKind } from 'components/role-badge';
import type { VerifiedBadge } from 'components/verified-tick';

/** Một dòng GET /vote-admin/:voteId/entries (backend src/vote/vote-admin.service.ts). */
export interface VoteEntry {
  id: number;
  score: number;
  createdAt: string;
  user: {
    id: number;
    username: string;
    nickName?: string | null;
    tiktokUid?: string | null;
    avatar?: string | null;
    verifiedBadge?: VerifiedBadge | null;
  } | null;
  memberType: string;
  memberLabel: string;
  affiliation: {
    /** Nhóm quản lý (= Studio / Agency trong trang Nhóm quản lý) */
    group: { id: number; title: string } | null;
    /** Trưởng nhóm của Nhóm quản lý (groups.ownerId) */
    manager: { id: number; name: string; label: string } | null;
    /** Nhóm nhảy hiện tại trong Studio */
    team: { id: number; name: string; leaderName?: string | null } | null;
    /** Phòng ban (Nhân viên) */
    department: string | null;
    /** Chưa vào Nhóm quản lý nào: tên Agency trong file TikTok gần nhất */
    fileAgency: string | null;
    /** Agency / Quản lý: các Nhóm quản lý người này đứng tên */
    owns?: { id: number; title: string }[];
  };
  /** Tổng điểm cộng/trừ tay và số lần chỉnh */
  manual: { total: number; count: number };
}

export interface VoteEntriesResponse {
  vote: { id: number; title: string; score: number };
  items: VoteEntry[];
}

export interface VoteScoreLog {
  id: number;
  entryId: number | null;
  action: 'ADJUST' | 'RESET' | 'REMOVE';
  delta: number;
  scoreBefore: number | null;
  scoreAfter: number | null;
  reason: string | null;
  actorName: string | null;
  createdAt: string;
  candidate: { id: number; nickName?: string; username?: string } | null;
}

/** memberType backend → huy hiệu sticker dùng chung (components/role-badge). */
export const MEMBER_BADGE: Record<string, RoleBadgeKind | undefined> = {
  ADMIN: 'ADMIN',
  SMOD: 'MOD',
  OPS_MANAGER: 'MANAGER',
  STAFF: 'STAFF',
  CREATOR_ONLINE: 'CREATOR_ONLINE',
  CREATOR_STUDIO: 'CREATOR_STUDIO',
  CREATOR_NPC: 'CREATOR_NPC',
  CREATOR_DANCE: 'CREATOR_DANCE',
};

/** 3100 → "3.100" */
export const formatScore = (value?: number | null) =>
  String(Math.round(value ?? 0)).replace(/\B(?=(\d{3})+(?!\d))/g, '.');

export const displayName = (entry?: VoteEntry | null) =>
  entry?.user?.nickName || entry?.user?.username || `#${entry?.id ?? ''}`;

/** Lỗi backend (message) → câu dễ hiểu. */
export const apiErrorText = (e: any) => {
  const known: Record<string, string> = {
    ENTRY_NOT_FOUND: 'Người này không còn trong danh sách (có thể đã bị loại).',
    VOTE_NOT_FOUND: 'Không tìm thấy sự kiện.',
    REASON_REQUIRED: 'Cần ghi lý do (ít nhất 3 ký tự).',
    Forbidden: 'Chỉ Admin được làm thao tác này.',
    'Forbidden resource': 'Chỉ Admin được làm thao tác này.',
  };
  const message = Array.isArray(e?.message) ? e.message[0] : e?.message;
  return (
    known[message] || (typeof message === 'string' && message) || 'Có lỗi xảy ra, vui lòng thử lại.'
  );
};
